<template>
  <div
    :class="[
      contentToTailwindClasses({
        flexItems: alignment,
        alignment: alignment,
      }),
      {
        'pointer-events-none fixed bottom-0 left-0 right-0 z-20 w-full p-4 opacity-0 transition-opacity duration-300':
          willBeSticky,
      },
      {
        'pointer-events-auto opacity-100': isSticky,
      },
    ]"
    class="flex flex-col"
  >
    <div v-if="isMagnoliaEdit && sticky" class="editmode-info-box">
      <div class="container">Sticky while scrolling from {{ stickyFrom }}% to {{ stickyTo }}%</div>
    </div>

    <DownloadLinkComponent
      v-if="isDownloadLink(link)"
      :label="link?.label"
      :link="link"
      @click="customTrackingEvent ? trackCustomEvent(customTrackingEvent) : null"
    ></DownloadLinkComponent>
    <LinkComponent
      v-else
      :class="contentToTailwindClasses(link.style)"
      :link="link"
      :stretch-link="stretchLink"
      @click="customTrackingEvent ? trackCustomEvent(customTrackingEvent) : null"
    >
      {{ link?.label ?? "" }}
    </LinkComponent>
  </div>
</template>

<script setup>
import { contentToTailwindClasses } from "~/utils/helper/tailwind";
import { isDownloadLink } from "~/utils/helper/magnolia";
import LinkComponent from "./LinkComponent";
import DownloadLinkComponent from "./DownloadLinkComponent";
import { useWindowScroll, useWindowSize } from "@vueuse/core";
const { isMagnoliaEdit } = useMagnoliaContext();
import useNavigationTracking from "~/composables/tracking/useNavigationTracking";
const { trackCustomEvent } = useNavigationTracking();

const props = defineProps([
  "link",
  "alignment",
  "stretchLink",
  "sticky",
  "stickyFrom",
  "stickyTo",
  "customTrackingEvent",
]);

const isSticky = ref(false);
const willBeSticky = computed(() => props.sticky === true && isMagnoliaEdit.value === false);

if (willBeSticky.value) {
  onMounted(() => {
    // initialize sticky evaluation
    const { y } = useWindowScroll();
    const { height: windowHeight } = useWindowSize();
    const scrollPercentage = computed(() => {
      const totalHeight = document?.documentElement?.scrollHeight;
      const scrollableHeight = totalHeight - windowHeight.value;
      return Math.max(0, Math.round((y.value / scrollableHeight) * 100));
    });
    watch(scrollPercentage, () => {
      isSticky.value =
        scrollPercentage.value >= props.stickyFrom && scrollPercentage.value <= props.stickyTo;
    });
  });
}
</script>
